import {Routes} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth').then((m) => m.Login),
  },
  {
    path: '',
    canActivate: [MsalGuard],
    loadChildren: () => import('./core/layout').then((m) => m.navbarRoutes),
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./features/auth').then((m) => m.Unauthorized),
  },
];
